<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-scroll"></i></span>{{ 'ReceivingInstruction.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate}}" [(selected)]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="grid formgrid p-fluid">
            <div class="col-4 field">
              <div class="font-bold mt-0 mb-2">{{ 'ReceivingInstruction.SearchForm.ReceivingInstructionSearch' | translate }}</div>
              <div class="grid col-14 margin-top-1">
                <div class="col-6">
                  <p-radioButton formControlName="orderQueryScope" [value]="OrderQueryScopeEnum.personal"
                    label="{{ 'Purchase.Search.PersonalOrder' | translate }}"></p-radioButton>
                </div>
                <div class="col-6">
                  <p-radioButton formControlName="orderQueryScope" [value]="OrderQueryScopeEnum.all" label="{{ 'Purchase.Search.All' | translate }}"></p-radioButton>
                </div>
              </div>
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.ReceivingRequestHeader' | translate }}</label>
              <p-multiSelect
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  filterBy="label"
                  [options]="receivingTaskOptions"
                  appendTo="body"
                  formControlName="receivingRequestHeader"
                ></p-multiSelect>
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.ReceivingRequestDetail' | translate }}</label>
              <p-multiSelect
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  filterBy="label"
                  [options]="receivingDetailTaskOptions"
                  appendTo="body"
                  formControlName="receivingRequestDetail"
                ></p-multiSelect>
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.Facility' | translate }}</label>
              <laas-facility-dropdown 
                formControlName="facility" 
                [isSingle]="true">
              </laas-facility-dropdown> 
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.Vendor' | translate }}</label>
              <laas-multiSelect
                inputId="formVendorNumber"
                appendTo="body"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                formControlName="vendorNumber"
                [showToggleAll]="false"
                [virtualScroll]="true"
                [virtualScrollItemSize]="40"
                [options]="vendorNumberOptions">
              </laas-multiSelect>
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.HawbNo' | translate }}</label>
              <p-chips formControlName="hawbNo" separator="," (onAdd)="chipsAdd($event, 'hawbNo')"></p-chips>
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.InvoiceNo' | translate }}</label>
              <p-chips formControlName="invoiceNo" separator="," (onAdd)="chipsAdd($event, 'invoiceNo')"></p-chips>
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.ImportDeclarationNo' | translate }}</label>
              <p-chips formControlName="importDeclarationNo" separator="," (onAdd)="chipsAdd($event, 'importDeclarationNo')"></p-chips>
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.AdNo' | translate }}</label>
              <p-chips formControlName="adNo" separator="," (onAdd)="chipsAdd($event, 'adNo')"></p-chips>
            </div>
            <div class="col-4 field">
              <div class="mb-1">{{ 'ReceivingInstruction.SearchForm.Sku' | translate }}</div>
              <input
                  type="text"
                  pInputText
                  formControlName="sku"
                />
            </div>
            <!-- <div class="col-12 md:col-6 lg:col-4 mb-3">
              <laas-calendar
                #receivedDt
                [title]="'ReceivingInstruction.SearchForm.ReceivedDt'"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'receivedDt')">
              </laas-calendar>
            </div> -->
            <div class="col-12 md:col-6 lg:col-4 laas-calendar">
              <laas-calendar
                #createDt
                [title]="'ReceivingInstruction.SearchForm.CreateDt'"
                [defaultDate]="defaultCreateDt"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'createDt')">
              </laas-calendar>
            </div>
            <div class="col-4 field">
              <div class="mb-1" for="formIsNotify">{{ 'ReceivingInstruction.SearchForm.IsNotify' | translate }}</div>
              <div>
                <p-dropdown
                  [showClear]="true"
                  inputId="formIsNotify"
                  formControlName="isNotify"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="isNotifyOptions()"
                  appendTo="body"
                ></p-dropdown>
              </div>
            </div>
            <div class="col-4 field">
              <label>{{ 'ReceivingInstruction.SearchForm.DocStatus' | translate }}</label>
              <p-dropdown
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  filterBy="label"
                  [options]="docStatusOptions()"
                  [showClear]="true"
                  appendTo="body"
                  formControlName="docStatus"
                ></p-dropdown>
            </div>
            <div class="field col-12">
              <small><strong class="p-invalid">
                {{ 'ReceivingInstruction.SearchForm.Warning.NotifiedAndStatusdWarning' | translate }}
              </strong></small>
            </div>

          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate}}" (click)="searchBtnClick()"></button>
              <button pButton label="{{ 'Common.Button.Reset' | translate}}" class="p-button-secondary ml-2" (click)="resetBtnClick()"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <p-accordion [multiple]="true">
      <p-accordionTab
      header="{{ 'ReceivingInstruction.MainTable.Header' | translate }}"
      [(selected)]="isHeaderTableOpen"
      >
        <p-table
                #receivingHeaderTable
                laasDataTableSetting
                [tableKey]="headerPreferenceKey"
                [defaultColumns]="tableColumns()"
                (setPageSize)="setHeaderPageSize($event)"
                [selectable]="true"
                [value]="tableValue"
                [scrollable]="true"
                scrollHeight="500px"
                [reorderableColumns]="true"
                [resizableColumns]="true"
                [totalRecords]="pageInfo.totalRecords"
                (onPage)="tablePageChange($event)"
                (onSort)="tableSort($event)"
                (onRowSelect)="onRowSelect($event)"
                [rowsPerPageOptions]="[5, 10, 20, 30]"
                [showCurrentPageReport]="true"
                [paginator]="true"
                [(first)]="first"
                [rows]="5"
                [loading]="isHeaderLoading"
                [lazy]="true"
                dataKey="seqNo"
                currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
                selectionMode="single"
                [(selection)]="selectedRow"
                editMode="row"
                class="edittable"
                styleClass="p-datatable-gridlines p-datatable-striped mt-2 white-space: nowrap;">

          <ng-template pTemplate="caption">
            <laas-table-column-toggle
                    [optionsColumn]="tableColumns()"
                    [dataTable]="receivingHeaderTable">
            </laas-table-column-toggle>
            <laas-permission-button
                    permissionCode="EditReceivingInstruction"
                    type="button"
                    label="{{ 'NoEvidenceCheck.Button.EditOrView' | translate}}"
                    icon="fas fa-pen"
                    [class]="'p-button-warning p-button-raised ml-2'"
                    (onClick)="switchEditMode()"
                    [disabled]="!canEditTable"
                    style="color: white"
            ></laas-permission-button>
            <button
                    pButton
                    type="button"
                    label="{{ 'Common.Button.Save' | translate}}"
                    [disabled]="!editMode"
                    (click)="saveBtnClick()"
                    icon="fas fa-save"
                    class="p-button-raised ml-2"
            ></button>
            <button
                    pButton
                    class="p-button-danger p-button-raised ml-2"
                    label="{{ 'ReceivingInstruction.DetailTable.Restore' | translate }}"
                    [disabled]="!editMode"
                    (click)="restTableValueToDefaultValue()"
            ></button>
            <button
                    pButton
                    type="button"
                    label="{{ 'ReceivingInstruction.DetailTable.ReturnWms' | translate}}"
                    [disabled]="this.selectedRowsWithCheckBox.length == 0"
                    (click)="returnWmsBtnClick()"
                    icon="fas fa-save"
                    class="p-button-raised ml-2"
            ></button>
            <button
                    pButton
                    type="button"
                    label="{{ 'ReceivingInstruction.DetailTable.BatchUpdate' | translate}}"
                    [disabled]="this.selectedRowsWithCheckBox.length == 0 || !this.editMode"
                    (click)="showBatchUpdateDialog(true,'header')"
                    class="p-button-success p-button-raised ml-2"
            ></button>
            <button
                    pButton
                    type="button"
                    label="{{ 'Common.Button.BatchUploadFiles' | translate}}"
                    [disabled]="this.selectedRowsWithCheckBox.length == 0"
                    (click)="showFileUploadDialog()"
                    class="p-button-success p-button-raised ml-2"
            ></button>
          </ng-template>

          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              <col style="width: 3vw" />
              <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
            </colgroup>
          </ng-template>

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th>
                <p-checkbox
                        [(ngModel)]="headerChecked"
                        [binary]="true"
                        (onChange)="selectAllOrUnSelectAll($event)"
                ></p-checkbox>
              </th>
              <th
                      [pSortableColumn]="col.field"
                      [pSortableColumnDisabled]="!col.sort"
                      *ngFor="let col of columns"
                      pResizableColumn
                      pReorderableColumn
                      [attr.field]="col.field">
                <div class="flex">
                  {{ col.header | translate}}
                  <column-filter [tableColumn]="col"></column-filter>
                  <p-sortIcon [hidden]="!col.sort" [field]="col.field"></p-sortIcon>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template
                  pTemplate="body"
                  let-rowData
                  let-columns="columns"
                  let-rowIndex="rowIndex"
          >
            <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="headerOnRowClick(rowData)">
              <td>
                <p-checkbox
                        [value]="rowData"
                        [(ngModel)]="selectedRowsWithCheckBox"
                        [disabled]="!selectedRowsWithCheckBox"
                ></p-checkbox>
              </td>
              <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col.field">

                  <ng-container *ngSwitchCase="'__function'">
                <span *ngIf="checkAdvanceTask(rowData)" (click)="showTaskAdvanceDialog(true)" class="icon">
                  <i class="fas fa-pencil-alt" style="color: red;"
                     pTooltip="Need to Be Maintained AdvanceTask"></i>
                </span>
                  </ng-container>

                  <p-cellEditor *ngSwitchCase="'taskCode'">
                    <ng-template pTemplate="input">
                      <p-multiSelect
                              [filter]="true"
                              placeholder="{{ 'Common.DropDown.Select' | translate }}"
                              [options]="currentReceivingTaskOptions"
                              optionDisabled="isDisabled"
                              appendTo="body"
                              [(ngModel)]="rowData[col.field]"
                              class="p-fluid"
                              (onChange)="taskCodeOptionCahange('header')"
                      >
                      </p-multiSelect>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{
                        rowData[col.field]
                                | listOptionsMapping: this.receivingTaskOptions
                                | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                  </p-cellEditor>
                  <p-cellEditor
                          *ngSwitchCase="'taskRemark'"
                          class="p-fluid"
                  >
                    <ng-template pTemplate="input">
                      <input
                              pInputText
                              type="text"
                              required
                              [(ngModel)]="rowData[col.field]"
                              [disabled]="!this.canEditHeaderTaskRemark"
                      />
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{ rowData[col.field] | replaceNullWith: "-" }}
                      </div>
                    </ng-template>
                  </p-cellEditor>

                  <p-cellEditor *ngSwitchCase="'carbonCopyUsers'">
                    <ng-template pTemplate="input">
                      <laas-multiSelect
                              [filter]="true"
                              placeholder="{{ 'Common.DropDown.Select' | translate }}"
                              [options]="employeeListOptions"
                              appendTo="body"
                              [(ngModel)]="rowData[col.field]"
                              class="p-fluid"
                              (onChange)="taskCodeOptionCahange('header')"
                              [virtualScroll]="true"
                              [virtualScrollItemSize]="30"
                      >
                      </laas-multiSelect>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{
                        rowData[col.field]
                                | listOptionsMapping: this.employeeListOptions
                                | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                  </p-cellEditor>

                  <ng-container *ngSwitchCase="'file'">
                    <div class="tableData-responsive field">
                      <a *ngIf="rowData['docStatus'] != 'F' && rowData['docIds'] && rowData['docIds'].length > 0; else fileUpload"
                         href="javascript: void(0);"
                         (click)="showFiles($event, rowData)">
                        {{ 'Common.Button.ShowFile' | translate }}
                      </a>
                      <ng-template #fileUpload>
                        <a *ngIf="rowData['docStatus'] != 'F' && rowData.seqNo != -1; else emptyData"
                           href="javascript: void(0);"
                           (click)="showFiles($event, rowData)"
                        >
                          {{ 'Common.Button.FileUpload' | translate }}
                        </a>
                        <ng-template #emptyData>
                          -
                        </ng-template>
                      </ng-template>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'docStatus'">
                    <div class="overflow-text">{{ rowData[col.field] | optionsMapping: docStatusOptions() | replaceNullWith:'-'}}</div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'facility'">
                    <div class="overflow-text">{{ rowData[col.field] | optionsMapping: facilityOptions() | replaceNullWith:'-'}}</div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'isNotify'">
                    <div class="overflow-text">{{ rowData[col.field] | optionsMapping: isNotifyOptions() | replaceNullWith:'-'}}</div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'vendor'">
                    <div class="overflow-text">{{ rowData[col.field]}}</div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'priority'">
                    <div class="overflow-text">{{ rowData[col.field] | optionsMapping: transportPriorityOptions() | replaceNullWith:'-'}}</div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'advanceTaskRemark'">
                    <div
                      class="overflow-text">{{ rowData[col.field] | advanceTaskPipe: receivingTaskOptions:advanceTaskCodePipe| replaceNullWith:'-'}}</div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <ng-container [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchCase="'date'">
                        <div class="overflow-text">{{ rowData[col.field] | date: "yyyy-MM-dd HH:mm" | replaceNullWith:'-'}}</div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                      </ng-container>
                    </ng-container>
                  </ng-container>

                </ng-container>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">
                {{ "Common.Table.NoData" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>

      <p-accordionTab
      header="{{ 'ReceivingInstruction.DetailTable.Header' | translate }}"
      [(selected)]="isDetailTableOpen"
      >
        <p-table
                #receivingDetailTable
                [hidden]="!firstSearch"
                laasDataTableSetting
                [tableKey]="detailPreferenceKey"
                [defaultColumns]="detailTableColumns"
                (setPageSize)="setDetailPageSize($event)"
                [value]="this.displayDetailModeByLine ? detailTableValue:detailGroupBySkuData"
                [columns]="detailTableColumns"
                [scrollable]="true"
                [selectable]="true"
                scrollHeight="500px"
                [reorderableColumns]="true"
                [resizableColumns]="true"
                [totalRecords]="detailPageInfo.totalRecords"
                (onPage)="detailTablePageChange($event)"
                (onSort)="detailTableSort($event)"
                [rowsPerPageOptions]="[5, 10, 20, 30]"
                [showCurrentPageReport]="true"
                [paginator]="true"
                [rows]="this.detailPageInfo.pageSize"
                [loading]="isDetailLoading"
                [lazy]="true"
                currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
                selectionMode="single"
                editMode="row"
                dataKey="seqNo"
                class="edittable"
                [(selection)]="selectedDetailRow"
                styleClass="p-datatable-gridlines p-datatable-striped mt-2 white-space: nowrap;">


          <ng-template pTemplate="caption">
            <div  class="flex justify-content-between">
              <div>
                <laas-table-column-toggle
                  [optionsColumn]="detailTableColumns"
                  [dataTable]="receivingDetailTable">
                </laas-table-column-toggle>
                <button
                  pButton
                  type="button"
                  label="{{ 'ReceivingInstruction.DetailTable.BatchUpdate' | translate}}"
                  class="p-button-success p-button-raised ml-2"
                  [disabled]="this.detailSelectedRowsWithCheckBox.length == 0 || !this.editMode"
                  (click)="showBatchUpdateDialog(true,'detail')"
                ></button>
              </div>
              <div>
                <p-selectButton [options]="displayModeOptions" [(ngModel)]="detailSelectedDisplayMode" (onChange)="checkDetailDisplayMode()"></p-selectButton>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              <col style="width: 3vw" />
              <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
            </colgroup>
          </ng-template>

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th>
                <p-checkbox
                  [(ngModel)]="detailChecked"
                  [binary]="true"
                  (onChange)="detailSelectAllOrUnSelectAll($event)"
                ></p-checkbox>
              </th>
              <th
                      [pSortableColumn]="col.field"
                      *ngFor="let col of columns"
                      pResizableColumn
                      pReorderableColumn
                      [attr.field]="col.field">
                <div class="flex">
                  {{ col.header | translate}}
                  <column-filter [tableColumn]="col"></column-filter>
                  <p-sortIcon [hidden]="!col.sort" [field]="col.field"></p-sortIcon>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template
                  pTemplate="body"
                  let-rowData
                  let-columns="columns"
                  let-rowIndex="rowIndex"
          >
            <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="detailOnRowClick(rowData)">
              <td>
                <p-checkbox
                  [value]="rowData"
                  [(ngModel)]="detailSelectedRowsWithCheckBox"
                  [disabled]="!detailSelectedRowsWithCheckBox"
                ></p-checkbox>
              </td>
              <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col.field">
                  <p-cellEditor *ngSwitchCase="'taskCode'">
                    <ng-template pTemplate="input">
                      <p-multiSelect
                              [filter]="true"
                              placeholder="{{ 'Common.DropDown.Select' | translate }}"
                              [options]="currentReceivingDetailTaskOptions"
                              optionDisabled="isDisabled"
                              appendTo="body"
                              [(ngModel)]="rowData[col.field]"
                              class="p-fluid"
                              (onChange)="taskCodeOptionCahange('detail')"
                      >
                      </p-multiSelect>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{
                        rowData[col.field]
                                | listOptionsMapping: this.receivingDetailTaskOptions
                                | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                  </p-cellEditor>
                  <p-cellEditor
                          *ngSwitchCase="'taskRemark'"
                          class="p-fluid"
                  >
                    <ng-template pTemplate="input">
                      <input
                              pInputText
                              type="text"
                              required
                              [(ngModel)]="rowData[col.field]"
                              [disabled]="!this.canEditDetailTaskRemark"
                              (input)="taskCodeOptionCahange('detail')"
                      />
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{ rowData[col.field] | replaceNullWith: "-" }}
                      </div>
                    </ng-template>
                  </p-cellEditor>

                  <ng-container *ngSwitchCase="'expectedQty'">
                    <div
                            class="overflow-text">{{ rowData[col.field]|number:'1.0':'en-US' | replaceNullWith:'-'}}</div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <ng-container [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchCase="'date'">
                        <div class="overflow-text">{{ rowData[col.field] | date: "yyyy-MM-dd HH:mm": this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">
                {{ "Common.Table.NoData" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
    </p-accordion>

  </p-card>

  <laas-receiving-instruction-batch-update
     #instructionBatchUpdate
    [(visible)]="isShowBatchUpdate"
    (visibleChange)="showBatchUpdateDialog($event,undefined)"
    (updateReceivingInstruction)="updateReceivingInstruction($event)"
    [advanceTaskListObject]="this.advanceTaskCode"
    [consigneeKeyOptions]="this.consigneeKeyOptions"
    [vendorNumberOptions]="this.vendorNumberOptions"
    [lockReasonOptions]="this.lockReasonOptions"
    [lockTypeOptions]="this.lockTypeOptions"
    [receivingTaskCodeGroupLogic] = "this.receivingTaskCodeGroupLogic"
    [selectedAdNoList]="getSelectedAdNoList()"
  >
  </laas-receiving-instruction-batch-update>

  <laas-file-upload-dialog
    #fileDialog
    [title]="'ReceivingInstruction.Dialog.File.Header'"
    (saveDataChanges)="saveFile($event)"
    (restoreFileData)="restoreFileData()"
    [context]="'ReceivingInstruction'">
  </laas-file-upload-dialog>

  <laas-advance-task-maintenance
          #advanceTaskMaintenance
          [(visible)]="visibleTaskAdvance"
          (updateAdvanceTask)="updateAdvanceTask($event)"
          [propTaskList]="this.selectedRow"
          [advanceTaskListObject]="this.advanceTaskCode"
          [consigneeKeyOptions]="this.consigneeKeyOptions"
          [vendorNumberOptions]="this.vendorNumberOptions"
          [lockReasonOptions]="this.lockReasonOptions"
          [lockTypeOptions]="this.lockTypeOptions"
          [receivingTaskOptions]="this.receivingTaskOptions"
  >
  </laas-advance-task-maintenance>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
